import { useEffect } from 'react';

import { ToastContainer } from 'react-toastify';

import type { ACCOUNT_IDENTITY } from '@/_config';
import useIsMounted from '@/_shared/hooks/use-is-mounted';
import { setAuthTokens } from '@/_shared/services/auth-cookies';
import googleAnalytics4 from '@/_shared/services/google-analytics-4';
import { useInitHotJar } from '@/_shared/services/hotjar';
import { getQueryStringValue } from '@/_shared/utils/helper';
import { setUUID } from '@/_shared/utils/unique-Id';
import { invalidateMeDep } from '@/_student/profile/persistent-actions';
import { router } from '@/router';
import 'react-toastify/dist/ReactToastify.css';

declare global {
  interface Window {
    previousPage: null | string;
    isDev?: boolean;
  }
}

window.previousPage = null;

export default function Administrator() {
  const access = getQueryStringValue('access');
  const refresh = getQueryStringValue('refresh');
  const type = getQueryStringValue('type');
  const hotJarStateChange = useInitHotJar();

  useEffect(() => {
    const trackRoute = (pathname: string) => {
      hotJarStateChange(pathname);
      window.scrollTo(0, 0);
    };

    trackRoute(router.state.location.pathname);

    const unsubscribe = router.subscribe('onResolved', (event) => {
      trackRoute(event.toLocation.pathname);
    });

    return unsubscribe;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useIsMounted(() => {
    googleAnalytics4.init();

    if (access && refresh) {
      invalidateMeDep();
    }
  });

  // Should run in first cycle
  // do not push inside effect
  if (access && refresh) {
    window.isDev = true;
    if (window.isDev) {
      console.log(window.location);
      console.warn('Dev mode on');
    }
    setUUID();
    setAuthTokens(access, refresh, type as ACCOUNT_IDENTITY);
  }

  return (
    <ToastContainer
      limit={5}
      position="bottom-left"
      autoClose={6000}
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnHover
      toastClassName="py-6 px-5 rounded-xl text-sm font-sans text-accent-light items-start"
    />
  );
}
